/* @ngInject */
export default function () {
	return {
		UNLOADED: 'UNLOADED',
		LOADING:  'LOADING',
		LOADED:   'LOADED',
		ERRORED:  'ERRORED',
	};
};


// WEBPACK FOOTER //
// ./src/js/constants/statuses.js